import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { Checkbox } from "@mui/material";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
import { EditAndDeleteButtons } from "../../../../../../../shared/data-entries/EditAndDeleteButtons";
import { ManualAutoButton } from "../../../../../../../shared/data-entries/ManualAutoButton";
import { useDataEntryContext } from "../../../../context/reducer.provider";
import { Charge } from "../../../../models/eaf.models";

const NotFitCheckbox = ({
  charge,
  onChange,
}: {
  charge: Charge;
  onChange: (charge: Charge, checked: boolean) => void;
}) => {
  const {
    state: { isDataLoading, isSubmitLoading },
  } = useDataEntryContext();

  return (
    <Checkbox
      color="primary"
      checked={charge.IsNotFit}
      onChange={(_, checked) => onChange(charge, checked)}
      disabled={isDataLoading || isSubmitLoading}
    />
  );
};

type Props = {
  deleteCharge: (chargeId: number) => void;
  editCharge: (chargeId: number) => void;
  editNotFit: (charge: Charge, checked: boolean) => void;
};

export const useTableData = ({
  deleteCharge,
  editCharge,
  editNotFit,
}: Props) => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Charges",
      children: [
        {
          field: "manual-auto",
          headerName: " ",
          flex: 1,
          cellRenderer: ManualAutoButton,
          cellRendererParams: (params: ICellRendererParams<Charge>) => ({
            isManual: (params.data as Charge).IsChargeManual,
          }),
        },
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) => {
            if (params.data?.Timestamp) {
              return dxtToLocalServerTime(
                (params.data as Charge).Timestamp,
                "HH:mm",
              );
            }
          },
        },
        {
          field: "BucketName",
          headerName: "Bucket",
          flex: 2,
        },
        {
          field: "Weight",
          headerName: "Weight [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) =>
            params.data?.Weight?.toFixed(0) || "0",
        },
        {
          field: "Lime",
          headerName: "Lime [lbs]",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Charge>) =>
            params.data?.Lime?.toFixed(0) || "0",
        },
        {
          field: "IsNotFit",
          headerName: "Not fit",
          flex: 1,
          cellRenderer: NotFitCheckbox,
          cellRendererParams: (params: ICellRendererParams<Charge>) => ({
            charge: params.data as Charge,
            onChange: editNotFit,
          }),
          cellStyle: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        },
        {
          field: "actions",
          headerName: " ",
          flex: 2,
          cellRenderer: EditAndDeleteButtons,
          cellRendererParams: (params: ICellRendererParams<Charge>) => ({
            deleteItem: deleteCharge,
            onEdit: editCharge,
            id: (params.data as Charge).ChargeId,
          }),
        },
      ],
    },
  ];

  return { columns };
};
